export default function valWithinBounds(v, a, b) {
    if (v < a) return a;
    if (v > b) return b;
    return v;
}